import { render, staticRenderFns } from "./CallPeriods.vue?vue&type=template&id=2275c440"
import script from "./CallPeriods.vue?vue&type=script&lang=js"
export * from "./CallPeriods.vue?vue&type=script&lang=js"
import style0 from "./CallPeriods.vue?vue&type=style&index=0&id=2275c440&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports